import {
    createOlympiadParticipant,
  } from "../repositories/olympiadRepository.js";
  
  export default {
    createOlympiadParticipant: async (body) => await createOlympiadParticipant(body),
  };